import React from 'react';
import { PieChart, Pie, Legend, Tooltip, Cell, ResponsiveContainer, Text } from 'recharts';
import {getColorsList, getRandomColor, getRandomInArray} from "../../services/UtilsService";
import styles from './MyCharts.module.css';
import MyLegend from "./MyLegend";

const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
    const radius = outerRadius * 1.1;
    const x = cx + radius * Math.cos(-midAngle * Math.PI / 180);
    const y = cy + radius * Math.sin(-midAngle * Math.PI / 180);
    return (
        <text x={x} y={y} fill="#333" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {`${(percent * 100).toFixed(0)}%`}
        </text>
    );
};

const MyDonut = ({ data, title = "", totalValue = null}) => {
    if (!data) return null;

    if (totalValue === null) {
        totalValue = data.reduce((acc, cur) => acc + cur.value, 0);
    }

    const cx = "50%";
    const height = 450;
    const cy =  height / 2.184; // 450 -> 206

    return (
        <ResponsiveContainer width="100%" height={450}>
            <PieChart>
                <Pie
                    data={data}
                    cx={cx}
                    cy={cy}
                    label={renderCustomLabel}
                    labelLine={false}
                    outerRadius="70%"
                    innerRadius="55%"
                    dataKey="value"
                >
                    {data.map((entry, index) => (
                        <Cell
                            key={`cell-${index}`}
                            fill={entry.fill || getRandomColor() }
                            stroke={ entry.fillBorder || null }
                            strokeWidth={2}
                        />
                    ))}
                </Pie>
                <text x={cx} y={cy} textAnchor="middle" dominantBaseline="central" alignmentBaseline="middle"  className="chart-number">
                    <tspan fontSize="30" fontWeight="bold">{totalValue}</tspan>
                    <tspan fontSize="15" x={cx} dy="1.2em">{title}</tspan>
                </text>
                <Tooltip />
                <Legend content={MyLegend} />
            </PieChart>
        </ResponsiveContainer>
    );
};

export default MyDonut;
